const path = /KAKAOTALK/i

/**
 *
 * @param userAgent window.navigator.userAgent
 */
function isKakaoBrowser(userAgent: string): boolean {
  return path.test(userAgent)
}

export default isKakaoBrowser
